module.exports = __webpack_public_path__ + "img/figure0-main.218db132.png";